import {
  isNotNull,
  OnboardingStepType,
  OrganizationDetailFragment,
  useStartOnboardingStep,
} from '@alice-financial/alice-sdk'
import * as React from 'react'
import { OrganizationFunding } from './funding/OrganizationFunding'
import { PaygroupFundingList } from './funding/PaygroupFunding'

type ConnectPaymentMethodStepProps = {
  org: OrganizationDetailFragment
  readonly?: boolean
}
export const ConnectPaymentMethodStep = ({ org, readonly }: ConnectPaymentMethodStepProps) => {
  const { mutate: startOnboardingStep } = useStartOnboardingStep(org.id)

  // Start CONNECT_BANKING step when payment method connection interface is accessed
  React.useEffect(() => {
    if (!org.onboardingWorkflow) return
    startOnboardingStep({ stepType: OnboardingStepType.ConnectBanking })
  }, [startOnboardingStep, org.onboardingWorkflow])

  if (org.aliceCardProgram.hasUnifiedBanking) {
    return <OrganizationFunding org={org} readonly={readonly} />
  }
  return <PaygroupFundingList paygroups={org.employers.filter(isNotNull)} readonly={readonly} />
}
